module.exports = __webpack_public_path__ + "img/dark_blonde.6698648c.svg";